import React from 'react';
import { useIsTextTruncated } from '../../util/formatters';
import { Maybe } from '../../generated/graphql';
import './truncated_text.scss';
import { Tooltip } from '../Tooltip/Tooltip';

interface Props {
  text: Maybe<string>;
}

export function TruncatedText({ text }: Props): JSX.Element {
  const [ref, isTruncated] = useIsTextTruncated();

  return (
    <div className="truncated-text" ref={ref}>
      {text}
      {isTruncated && (
        <Tooltip reference={<span className="truncated-text__tooltip-anchor" />} position="bottom-end">
          <div className="truncated-text__tooltip">{text}</div>
        </Tooltip>
      )}
    </div>
  );
}
